<div class="menu-overlay" [ngClass]="{'active': isMenuActive}" (click)="closeFilter()"></div>
<div class="filter-menu" [ngClass]="{'active': isMenuActive}" [class.filter-menu-big]="isBigMenu">
    <div class="container">
        <div class="row">
            <div class="col-lg col-md">
                <h3>Filtro Detalhado</h3>
            </div>
            <div class="col-lg-2 col-md-2">
                <i class="fa fa-close fa-2x iconClose" (click)="closeFilter()" matTooltip="Fechar"></i>
            </div>
        </div>
        <ng-content></ng-content>
    </div>
</div>